/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc
 */
import * as References from './FeaturedCalloutsPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc#getAllPublished
 */
export const GET_ALL_PUBLISHED_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_FeaturedCalloutsPublicRpc_getAllPublished';
export const GET_ALL_PUBLISHED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PUBLISHED_QUERY_FIELD_NAME,
  args: ['productType', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllPublishedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc#getRelevantPublishedCalloutIds
 */
export const GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_FeaturedCalloutsPublicRpc_getRelevantPublishedCalloutIds';
export const GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY_FIELD_NAME,
  args: ['productType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getRelevantPublishedCalloutIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});